import * as React from 'react';

import FolderPlane140 from './FolderPlane140';

export const folderPlane140 = () => <FolderPlane140 />;

export default {
    title: 'Illustration/FolderPlane140',
    component: FolderPlane140,
    parameters: {
        notes: "`import FolderPlane140 from 'box-ui-elements/es/illustration/FolderPlane140';`",
    },
};
